export default {
	name: 'sellbooks',
	data() {
		return {
			searchText: '',
			searchBookCode: '',
			getCustomer: {},
			getBook: {},
			customer: null,
			books: [],
			borrowCount: 0,
			OperatorID: this.$store.state.user.UserID,
			ShopID: this.$store.state.user.ShopID,
			actioning: false
		}
	},
	created() {
		this.getCustomer = function() {
			this.$request.request({
				url: 'borrowAndReturn/getCustomerByCodeAndPhone',
				data: {
					searchText: this.searchText
				},
				method: 'post'

			}).then(res => {
				if (res.result) {
					this.customer = res.customer;
					this.searchText = this.customer.CustomerPhone;
				} else {
					this.$uil.showMessage({
						text: res.message
					});
					this.searchText = "";
				}
			})
		}

		this.getBook = function() {

			if (this.customer == null) {
				this.$uil.showMessage({
					text: '请先确认会员信息'
				});
				return;
			}
			let booksum = 0;
			for (let i of this.books)
				booksum += i.count;
			this.$request.request({
				url: 'borrowAndReturn/getBookByBookCode',
				data: {
					searchText: this.searchBookCode.trim()
				},
				method: 'post'

			}).then(res => {
				if (res.result) {
					let book = res.book;
					if (book.BooksSate == 2 || book.BooksSate == 1) {
						this.$uil.showMessage({
							text: book.BooksSate == 1 ? '该书已经下架' : '该书已经借出'
						});
						this.searchBookCode = '';
						return;
					}
					let isAdd = false;
					for (let i of this.books) {
						if (i.BooksID == book.BooksID) {
							for (let j of i.books) {
								if (j.BookDetailID == book.BookDetailID) {
									this.$uil.showMessage({
										text: '该书已经添加至借书单'
									});
									this.searchBookCode = '';
									return;

								}
							}
							i.books.push({
								'BookDetailID': book.BookDetailID,
								'BooksNumCode': book.BooksNumCode,
								'ShopID': book.ShopID,
								'ShopName': book.ShopName,
								'CurrentPlace': book.CurrentPlace,
								'BookPrice': book.BookPrice,
								'payMoney': book.BookPrice
							});
							i.count++;
							isAdd = true;
							break;
						}
					}
					if (!isAdd) {
						this.books.push({
							'BooksName': book.BooksName,
							'BooksID': book.BooksID,
							'count': 1,
							'books': [{
								'BookDetailID': book.BookDetailID,
								'BooksNumCode': book.BooksNumCode,
								'ShopID': book.ShopID,
								'ShopName': book.ShopName,
								'CurrentPlace': book.CurrentPlace,
								'BookPrice': book.BookPrice,
								'payMoney': book.BookPrice
							}]
						});

					}
					this.searchBookCode = '';
				} else {
					this.$uil.showMessage({
						text: res.message
					});
				}
			})


		}
	},
	methods: {
		searchBook(e) {

			if (e.keyCode == 13)
				this.getBook();
		},
		searchCustomers(e) {

			if (e.keyCode == 13)
				this.getCustomer();
		},
		removeBook(index) {
			this.books.splice(index, 1);
		},
		borrowBooks() {
			if (this.actioning) {
				this.$uil.showMessage({
					text: '数据提交中'
				})
				return;
			}
			this.actioning = true;
			let sum = 0;
			let FreightMoney = 0;
			let ActualPayment = 0;
			for (let i of this.books) {
				sum += i.count;
				for (let s of i.books) {
					FreightMoney += s.BookPrice * 1;
					ActualPayment += s.payMoney * 1;
				}
			}

			this.$request.request({
				url: 'borrowAndReturn/sellbooks',
				data: {
					CustomerID: this.customer.CustomerID,
					BorrowCount: sum,
					ShopID: this.ShopID,
					OperatorID: this.OperatorID,
					borrowBook: JSON.stringify(this.books),
					ActualPayment: ActualPayment, //应付价钱
					FreightMoney: FreightMoney //实付价钱
				},
				method: 'post'

			}).then(res => {
				this.$uil.showMessage({
					text: res.message
				});
				this.customer = null;
				this.books = [];
				this.searchText = "";
				this.actioning = false;
			});

		}

	},
	computed: {
		borrowCountSum() {
			let sum = 0;
			for (let i of this.books)
				sum += i.count;
			return '合计:' + sum + '本';

		},
		payMoney() {
			let sum = 0;
			for (let i of this.books) {
				for (let j of i.books) {
					sum += j.payMoney * 1;
				}
			}
			return sum;

		}
	}
}
